// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"318":"16df5cac10333c3e","697":"335a7dea212ace55"}[chunkId] + ".js";
};